var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUnicornnest = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#22262A",
    strokeWidth: 1.339,
    d: "M13 25.25c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#22262A",
    fillRule: "evenodd",
    d: "M11.342 18.057c-.03-.144.142-.23.228-.115.515.859 1.43 1.975 2.402 2.576a.2.2 0 0 0 .114.058c.114.057.286.085.4.057a7.7 7.7 0 0 0 1.43-.487 9.3 9.3 0 0 0 1.515-1.002c.2-.171.429-.372.6-.6.172-.173.029-.488-.229-.488-.686.03-1.4.03-2.086-.028a2.7 2.7 0 0 1-1.23-.4 3.04 3.04 0 0 1-1.058-1.031c-.343-.544-.657-1.146-.743-1.804-.057-.315-.086-.715.057-1.002.086-.229.343-.286.543-.114.086.086.143.2.2.286.287.458.744.859 1.287.945.457.086.772.171 1.23.143.4-.029.714 0 1.057.257.486.344.8.83 1.487.516.372-.172.629-.516.858-.86.371-.6.571-1.402-.315-1.602-.286-.057-.6-.286-.83-.515-.714-.773-2.172-2.376-2.715-2.949a.39.39 0 0 1-.029-.458c.258-.315.687-.887.887-1.116.629-.83 1.315-1.718 1.83-2.376.085-.115-.058-.258-.172-.172-.715.515-1.773 1.346-2.687 2.004-.372.286-.715.515-.973.716-.028 0-.028.028-.057.028a.43.43 0 0 1-.543-.057l-.029-.029-1.715-1.946c-.171-.2-.514-.115-.572.172l-.114.887s0 .029-.028.029c-.372.085-.715.229-1.058.372a1.4 1.4 0 0 0-.2.086l-.172.085h-.029c-.143.058-.257.144-.4.23-1.915 1.202-3.202 3.32-3.202 5.725v.257c.029.63.143 1.231.315 1.804a6.72 6.72 0 0 0 2.573 3.435c1.229.744 2.659 1.059 3.402 1.173.171.029.257-.171.171-.286-.429-.515-1.143-1.517-1.4-2.404",
    clipRule: "evenodd"
  })));
};
export default SvgUnicornnest;